// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4c3fb29c","453":"3154de31"}[chunkId] + ".chunk.js";
};